import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-joey-navy py-16 px-8 max-md:px-5">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          {/* Product Section */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-6 max-md:text-base">Product</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/features/contact-verification"
                  className="text-gray-300 hover:text-white transition-colors text-base max-md:text-sm"
                >
                  Contact Verification
                </Link>
              </li>
              <li>
                <Link
                  to="/features/iphone-monitoring"
                  className="text-gray-300 hover:text-white transition-colors text-base max-md:text-sm"
                >
                  iPhone Monitoring
                </Link>
              </li>
              <li>
                <Link
                  to="/features/hows-my-child-report"
                  className="text-gray-300 hover:text-white transition-colors text-base max-md:text-sm"
                >
                  How's My Child?
                </Link>
              </li>
              <li>
                <Link
                  to="/features/smart-alerts"
                  className="text-gray-300 hover:text-white transition-colors text-base max-md:text-sm"
                >
                  Smart Alerts
                </Link>
              </li>
              <li>
                <Link
                  to="/features/analytics"
                  className="text-gray-300 hover:text-white transition-colors text-base max-md:text-sm"
                >
                  Analytics
                </Link>
              </li>
            </ul>
          </div>

          {/* About Section */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-6 max-md:text-base">About</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/pricing"
                  className="text-gray-300 hover:text-white transition-colors text-base max-md:text-sm"
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link
                  to="/about-us"
                  className="text-gray-300 hover:text-white transition-colors text-base max-md:text-sm"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/faqs"
                  className="text-gray-300 hover:text-white transition-colors text-base max-md:text-sm"
                >
                  FAQs
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-300 hover:text-white transition-colors text-base max-md:text-sm"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/security"
                  className="text-gray-300 hover:text-white transition-colors text-base max-md:text-sm"
                >
                  Security & Trust
                </Link>
              </li>
            </ul>
          </div>

          {/* Learn Section */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-6 max-md:text-base">Learn</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/articles"
                  className="text-gray-300 hover:text-white transition-colors text-base max-md:text-sm"
                >
                  Articles
                </Link>
              </li>
              <li>
                <Link
                  to="/articles/5/as-parent-why-i-created-this-app-joey"
                  className="text-gray-300 hover:text-white transition-colors text-base max-md:text-sm"
                >
                  Why I Created Joey
                </Link>
              </li>
              <li>
                <Link
                  to="/articles/30/what-is-the-joey-social-graph"
                  className="text-gray-300 hover:text-white transition-colors text-base max-md:text-sm"
                >
                  Joey Social Graph
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Section */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-6 max-md:text-base">Contact</h4>
            <ul className="space-y-3">
              <li>
                <span className="text-gray-300 text-base max-md:text-sm">Melbourne, Australia</span>
              </li>
              <li>
                <a
                  href="mailto:joey@joeyfamily.com"
                  className="text-gray-300 hover:text-white transition-colors text-base max-md:text-sm"
                >
                  joey@joeyfamily.com
                </a>
              </li>
              <li>
                <a
                  href="https://www.google.com/maps/place/JoeyFamily.com/@-37.7661356,145.0382284,17z/data=!4m6!3m5!1s0x6ad645b9bad63bcb:0xefaccaef878decd2!8m2!3d-37.7661356!4d145.0382284!16s%2Fg%2F11ymfx6tt_?hl=en-GB&entry=ttu&g_ep=EgoyMDI1MTExMi4wIKXMDSoASAFQAw%3D%3D"
                  className="text-gray-300 hover:text-white transition-colors text-base max-md:text-sm"
                  target="_blank"
                  rel="noreferrer"
                >
                  View on Google
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2025 JoeyFamily.com. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">
                Privacy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-white transition-colors">
                Terms
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
